<script setup>
</script>

<template>
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 8L18 14H6L12 8Z"></path>
    </svg>
</template>